import { render, staticRenderFns } from "./viewAd.vue?vue&type=template&id=24f96bf9&"
import script from "./viewAd.vue?vue&type=script&lang=js&"
export * from "./viewAd.vue?vue&type=script&lang=js&"
import style0 from "./viewAd.vue?vue&type=style&index=0&id=24f96bf9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports